export function modulo(a: number, b: number) {
    return ((a % b) + b) % b;
}
